import { IGetToothProblemsParams } from "../../../types";

// Endpoint za kreiranje problema zuba
export const createToothProblemEndpoint = () => {
  return `/tooth-problem`;
};

// Endpoint za ažuriranje problema zuba
export const updateToothProblemEndpoint = (problemId: string) => {
  return `/tooth-problem/${problemId}`;
};

// Endpoint za označavanje problema kao riješenog
export const markToothProblemAsSolvedEndpoint = (problemId: string) => {
  return `/tooth-problem/${problemId}/solve`;
};

// Endpoint za dohvaćanje problema zuba klijenta
export const getClientToothProblemsEndpoint = (clientId: string, params?: IGetToothProblemsParams) => {
  let endpoint = `/tooth-problem/client/${clientId}`;
  
  if (params) {
    const queryParams = new URLSearchParams();
    
    if (params.toothNumber !== undefined) {
      queryParams.append('toothNumber', params.toothNumber.toString());
    }
    
    if (params.onlyCurrent !== undefined) {
      queryParams.append('onlyCurrent', params.onlyCurrent.toString());
    }
    
    if (queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
  }
  
  return endpoint;
};

// Endpoint za dohvaćanje problema specifičnog zuba
export const getToothProblemsEndpoint = (
  clientId: string,
  toothNumber: number,
  onlyCurrent?: boolean
) => {
  let endpoint = `/tooth-problem/tooth/${clientId}/${toothNumber}`;
  
  if (onlyCurrent !== undefined) {
    endpoint += `?onlyCurrent=${onlyCurrent.toString()}`;
  }
  
  return endpoint;
}; 